import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'ri-building-2-line',
    title: 'Office Cleaning',
    desc: 'Daily and scheduled office cleaning tailored to your workspace. Desks, floors, common areas — spotless before your team arrives.',
    img: 'https://public.readdy.ai/ai/img_res/7b02fa8d1de4978ecd6ca56a4bae5080.jpg',
    href: '/services/office-cleaning',
  },
  {
    icon: 'ri-brush-3-line',
    title: 'Janitorial Services',
    desc: 'Comprehensive janitorial maintenance for all facility areas — consistent, professional, and built around your schedule.',
    img: 'https://readdy.ai/api/search-image?query=professional%20commercial%20janitor%20cleaning%20large%20office%20hallway%20commercial%20mop%20bucket%20uniform%20professional%20service%20bright%20corridor%20polished%20floors%20commercial%20building%20interior&width=600&height=400&seq=svc002&orientation=landscape',
    href: '/services/office-cleaning',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Floor Care & Maintenance',
    desc: 'Stripping, waxing, buffing, and maintenance for hardwood, tile, vinyl, and all commercial flooring types.',
    img: 'https://readdy.ai/api/search-image?query=professional%20commercial%20floor%20buffing%20machine%20polishing%20gleaming%20tile%20floor%20large%20commercial%20building%20interior%20bright%20lights%20reflective%20polished%20surface%20professional%20cleaning%20equipment%20industrial%20floor%20care&width=600&height=400&seq=svc003&orientation=landscape',
    href: '/services/office-cleaning',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Carpet Cleaning',
    desc: 'Commercial steam and extraction carpet cleaning removing stains, allergens, and odors — restoring carpets to like-new condition.',
    img: 'https://readdy.ai/api/search-image?query=professional%20carpet%20cleaning%20service%20commercial%20office%20carpet%20steam%20extraction%20machine%20clean%20results%20before%20after%20professional%20service%20corporate%20environment%20clean%20carpet%20fiber%20closeup&width=600&height=400&seq=svc004&orientation=landscape',
    href: '/services/office-cleaning',
  },
  {
    icon: 'ri-drop-line',
    title: 'Restroom Sanitation',
    desc: 'Deep disinfection of all restroom surfaces using hospital-grade products — maintained to the highest hygiene standards.',
    img: 'https://readdy.ai/api/search-image?query=clean%20modern%20commercial%20restroom%20sparkling%20white%20tiles%20bright%20lights%20pristine%20sink%20fixtures%20immaculate%20bathroom%20professional%20sanitation%20result%20high%20end%20office%20building%20restroom%20clean%20polished&width=600&height=400&seq=svc005&orientation=landscape',
    href: '/services/office-cleaning',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Post-Construction Cleaning',
    desc: 'Complete post-construction cleanup — dust removal, debris disposal, and detail cleaning to prepare your space for occupancy.',
    img: 'https://readdy.ai/api/search-image?query=post%20construction%20cleaning%20commercial%20space%20professional%20cleaning%20crew%20new%20building%20interior%20finishing%20clean%20up%20dust%20removal%20bright%20new%20construction%20site%20sparkle%20clean%20professional%20team&width=600&height=400&seq=svc006&orientation=landscape',
    href: '/services/office-cleaning',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
              <span className="text-accent text-xs font-body font-semibold uppercase tracking-wider">What We Do</span>
            </div>
            <h2 className="font-heading font-extrabold text-navy text-4xl xl:text-5xl leading-tight">
              Commercial Cleaning<br />Services We Provide
            </h2>
          </div>
          <p className="text-gray-500 font-body text-lg max-w-sm lg:text-right leading-relaxed">
            From routine janitorial maintenance to specialized deep cleaning — built around your facility and schedule.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service) => (
            <Link
              key={service.title}
              to={service.href}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-accent/30 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden bg-gray-100">
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-lg group-hover:bg-accent transition-colors duration-300 shrink-0">
                    <i className={`${service.icon} text-accent group-hover:text-navy text-lg transition-colors duration-300`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-navy text-lg">{service.title}</h3>
                </div>
                <p className="text-gray-500 font-body text-sm leading-relaxed mb-4">{service.desc}</p>
                <div className="flex items-center gap-1.5 text-accent text-sm font-heading font-semibold">
                  Learn More <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="mt-14 bg-navy rounded-3xl p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading font-extrabold text-white text-2xl mb-2">Need a Custom Cleaning Plan?</h3>
            <p className="text-white/55 font-body text-base">Tell us about your facility and we&apos;ll build a plan that fits perfectly.</p>
          </div>
          <Link
            to="/contact"
            className="bg-accent hover:bg-accent-dark text-navy font-heading font-extrabold px-8 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap flex items-center gap-2 shrink-0"
          >
            Get a Custom Plan <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
